import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import ClientService from 'services/ClientService';
import { OBJECT_GROUPS } from 'queries/query-keys';
import CustomObjectsService from 'services/CustomObjectsService';
import type { FilterGroup } from '@kizen/api/custom-object';

// for now we just want to swallow the error and return an empty array
const safeFetch = async (
  groupOptionsId: string,
  isForCustomObject: boolean,
  trapError: boolean
): Promise<FilterGroup[]> => {
  try {
    return isForCustomObject
      ? groupOptionsId
        ? await CustomObjectsService.getRecordsGroups(groupOptionsId)
        : []
      : await ClientService.groups();
  } catch (error) {
    if (!trapError) {
      throw error;
    }
    return [];
  }
};

export const useObjectGroupsQuery = (
  groupOptionsId: string,
  isForCustomObject: boolean,
  options: Omit<UseQueryOptions<FilterGroup[]>, 'queryKey' | 'queryFn'> = {},
  trapError: boolean = true
) => {
  return useQuery<FilterGroup[]>({
    queryKey: OBJECT_GROUPS.OBJECT(groupOptionsId),
    queryFn: async () =>
      safeFetch(groupOptionsId, isForCustomObject, trapError),

    enabled: Boolean(groupOptionsId),
    ...options,
  });
};
